import PageTitle from "../Helpers/PageTitle";
import Layout from "../Partials/Layout";
import { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Layout childrenClasses="pt-0 pb-0">
      <div className="terms-condition-page w-full bg-white pb-[30px]">
        <div className="w-full mb-[30px]">
          <PageTitle
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "Privacy Policy", path: "privacy-policy" },
            ]}
            title="Privacy Policy"
          />
        </div>
        <div className="w-full">
          <div className="container-x mx-auto">
            <div className="content-item w-full mb-10">
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                At Items.lk, we are committed to protecting the privacy and
                security of our customers' personal information. This Privacy
                Policy outlines how we collect, use, and safeguard your
                information when you visit or make a purchase on our website. By
                using our website, you consent to the practices described in
                this policy.
              </p>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Information We Collect
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                When you visit our website, we may collect certain information
                about you, including:
              </p>
              <ul className="list-disc ml-5 mb-5">
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  Personal identification information (such as your name, email
                  address, and phone number) provided voluntarily by you during
                  the registration or checkout process.
                </li>
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  Payment and billing information necessary to process your
                  orders, including credit card details, which are securely
                  handled by trusted third-party payment processors.
                </li>
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  Browsing information, such as your IP address, browser type,
                  and device information, collected automatically using cookies
                  and similar technologies.
                </li>
              </ul>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Use of Information
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                We may use the collected information for the following purposes:
              </p>
              <ul className="list-disc ml-5 mb-5">
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  To process and fulfill your orders, including shipping and
                  delivery.
                </li>
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  To communicate with you regarding your purchases, provide
                  customer support, and respond to inquiries or requests.
                </li>
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  To personalize your shopping experience and present relevant
                  product recommendations and promotions.
                </li>
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  To improve our website, products, and services based on your
                  feedback and browsing patterns.
                </li>
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  To detect and prevent fraud, unauthorized activities, and
                  abuse of our website.
                </li>
              </ul>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Information Sharing
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                We respect your privacy and do not sell, trade, or otherwise
                transfer your personal information to third parties without your
                consent, except in the following circumstances:
              </p>
              <ul className="list-disc ml-5 mb-5">
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  Trusted service providers: We may share your information with
                  third-party service providers who assist us in operating our
                  website, processing payments, and delivering products. These
                  providers are contractually obligated to handle your data
                  securely and confidentially.
                </li>
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  Legal requirements: We may disclose your information if
                  required to do so by law or in response to valid legal
                  requests or orders.
                </li>
              </ul>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Data Security
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                We implement industry-standard security measures to protect your
                personal information from unauthorized access, alteration,
                disclosure, or destruction. However, please be aware that no
                method of transmission over the internet or electronic storage
                is 100% secure, and we cannot guarantee absolute security.
              </p>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Cookies and Tracking Technologies
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                We use cookies and similar technologies to enhance your browsing
                experience, analyze website traffic, and gather information
                about your preferences and interactions with our website. You
                have the option to disable cookies through your browser
                settings, but this may limit certain features and functionality
                of our website.
              </p>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Changes to the Privacy Policy
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                We reserve the right to update or modify this Privacy Policy at
                any time. Any changes will be posted on this page with a revised
                "last updated" date. We encourage you to review this Privacy
                Policy periodically to stay informed about how we collect, use,
                and protect your information.
              </p>
            </div>

            <div className="content-item w-full mb-10">
              <h2 className="text-[18px] font-medium text-qblack mb-4">
                Contact Us
              </h2>
              <p className="text-[15px] text-justify text-qgraytwo leading-7 mb-2">
                If you have any questions, concerns, or requests regarding our
                Privacy Policy or the handling of your personal information,
                please contact us using the information provided on our website.
              </p>
              <ul className="list-disc ml-5 mb-5">
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  By email: info@items.lk
                </li>
                <li className="text-[15px] text-justify text-qgraytwo leading-7">
                  By visiting this page on our website: www.items.lk
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
